<script setup>
import { usePage } from '@inertiajs/vue3';
import { captureContactClicked } from '@/Common/Posthog.js';

const { contact } = usePage().props.branding;
</script>

<template>
  <div class="flex">
    {{ $t('domain_score.partials.contact_us_for_assistance.none') }}
    <div v-if="contact?.href && contact?.for_assistance">
      &nbsp;-
      <a
        :href="contact.href"
        class="text-primary-400 hover:text-primary-500"
        target="_blank"
        @click="captureContactClicked"
      >
        {{ $t('domain_score.partials.contact_us_for_assistance.contact_us') }}
      </a>
      {{ $t('domain_score.partials.contact_us_for_assistance.for_assistance') }}
    </div>
  </div>
</template>
